export class Gestao {
    id = 0;
    estimativaId = 0;
    gestaoInformaInput = 0;
    gestaoInforma = 0;
    riscoTecnicoInput = 0;
    riscoTecnico = 0;
    totalProjeto = 0;
    totalProjetoGestao = 0;
    mediaEquipe = 0;
    custoHora = 0;
    totalHoras = 0;
}
